import { ON_PREMISE_SCREEN_SEAT_MAX_CHARS } from "../order-type-preference-options/constants";

export const ON_PREMISE_MOBILE_MAX_DIGITS = 10;

export function clampOnPremiseScreenSeatInput(value: string): string {
    return value.slice(0, ON_PREMISE_SCREEN_SEAT_MAX_CHARS);
}

export function clampOnPremiseMobileInput(value: string): string {
    return value.replace(/\D/g, "").slice(0, ON_PREMISE_MOBILE_MAX_DIGITS);
}
